import React, { FC, useState } from "react"
import { DateRangePicker } from "react-bootstrap-daterangepicker"
import moment from "moment"
import "bootstrap-daterangepicker/daterangepicker.css"

type Props = {
  onDateSelect?: (arg: { startDate: string; endDate: string }) => void
  minDate?: Date
  maxDate?: Date
  defaultStartDate?: Date
  defaultEndDate?: Date
}

const PredefinedDateRanges: FC<Props> = props => {
  const { onDateSelect = () => {}, minDate, maxDate, defaultStartDate, defaultEndDate } = props
  const [state, setState] = useState({
    start: defaultStartDate ? moment(defaultStartDate) : moment().subtract(29, "days"),
    end: defaultEndDate ? moment(defaultEndDate) : moment(),
  })

  const { start, end } = state

  const handleCallback = (start: moment.Moment, end: moment.Moment) => {
    setState({ start, end })
    onDateSelect({ startDate: start.format(), endDate: end.format() })
  }

  const ranges: Record<string, [moment.Moment, moment.Moment]> = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  }

  // Show the preset's name (e.g. "Today") instead of the raw date range
  // whenever the current selection exactly matches one of them.
  const matchedRangeName = Object.entries(ranges).find(
    ([, [rangeStart, rangeEnd]]) =>
      start.isSame(rangeStart, "day") && end.isSame(rangeEnd, "day")
  )?.[0]

  const label =
    matchedRangeName ||
    `${start.format("D MMMM, YYYY")} - ${end.format("D MMMM, YYYY")}`

  return (
    <DateRangePicker
      initialSettings={{
        startDate: start.toDate(),
        endDate: end.toDate(),
        ...(minDate && { minDate }),
        ...(maxDate && { maxDate }),
        ranges: Object.fromEntries(
          Object.entries(ranges).map(([name, [rangeStart, rangeEnd]]) => [
            name,
            [rangeStart.toDate(), rangeEnd.toDate()],
          ])
        ),
      }}
      onCallback={handleCallback}
    >
      <div
        id="reportrange"
        className="col-4"
        style={{
          background: "#fff",
          cursor: "pointer",
          padding: "0.5rem 0.625rem",
          border: "1px solid #E9EDF4",
          width: "100%",
          borderRadius: "5px",
          fontSize: "14px",
          color: "#202C4B",
          height: "38px",
        }}
      >
        <i className="ti ti-calendar"></i>&nbsp;
        <span>{label}</span>
      </div>
    </DateRangePicker>
  )
}

export default PredefinedDateRanges
